function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports, require('react-with-styles/lib/ThemedStyleSheet'), require('react-with-styles-interface-aphrodite'), require('react-dates/lib/theme/DefaultTheme'), require('react'), require('prop-types'), require('moment'), require('moment/locale/nl'), require('react-moment-proptypes'), require('object.entries'), require('react-redux'), require('redux'), require('object.omit'), require('classnames'), require('react-dates'), require('currencyformatter.js'), require('react-transition-group'), require('node-polyglot')) : typeof define === 'function' && define.amd ? define(['exports', 'react-with-styles/lib/ThemedStyleSheet', 'react-with-styles-interface-aphrodite', 'react-dates/lib/theme/DefaultTheme', 'react', 'prop-types', 'moment', 'moment/locale/nl', 'react-moment-proptypes', 'object.entries', 'react-redux', 'redux', 'object.omit', 'classnames', 'react-dates', 'currencyformatter.js', 'react-transition-group', 'node-polyglot'], factory) : (global = global || self, factory(global.Lannister = {}, global.ThemedStyleSheet, global.aphroditeInterface, global.DefaultTheme, global.React, global.PropTypes, global.moment, null, global.MomentPropTypes, global.entries, global.reactRedux, global.redux, global.omit, global.cn, global.reactDates, global.CurrencyFormatter, global.ReactTransitionGroup, global.Polyglot));
})(this, function (exports, ThemedStyleSheet, aphroditeInterface, DefaultTheme, React, PropTypes, moment, nl, MomentPropTypes, entries, reactRedux, redux, omit, cn, reactDates, CurrencyFormatter, reactTransitionGroup, Polyglot) {
  'use strict';

  ThemedStyleSheet = ThemedStyleSheet && ThemedStyleSheet.hasOwnProperty('default') ? ThemedStyleSheet['default'] : ThemedStyleSheet;
  aphroditeInterface = aphroditeInterface && aphroditeInterface.hasOwnProperty('default') ? aphroditeInterface['default'] : aphroditeInterface;
  DefaultTheme = DefaultTheme && DefaultTheme.hasOwnProperty('default') ? DefaultTheme['default'] : DefaultTheme;
  React = React && React.hasOwnProperty('default') ? React['default'] : React;
  PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;
  moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
  MomentPropTypes = MomentPropTypes && MomentPropTypes.hasOwnProperty('default') ? MomentPropTypes['default'] : MomentPropTypes;
  entries = entries && entries.hasOwnProperty('default') ? entries['default'] : entries;
  omit = omit && omit.hasOwnProperty('default') ? omit['default'] : omit;
  cn = cn && cn.hasOwnProperty('default') ? cn['default'] : cn;
  CurrencyFormatter = CurrencyFormatter && CurrencyFormatter.hasOwnProperty('default') ? CurrencyFormatter['default'] : CurrencyFormatter;
  Polyglot = Polyglot && Polyglot.hasOwnProperty('default') ? Polyglot['default'] : Polyglot;
  function _typeof(obj) {
    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
      _typeof = function _typeof(obj) {
        return _typeof2(obj);
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
      };
    }
    return _typeof(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized(self);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
      return;
    }
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  var core = {
    primary: '#4a5a64'
  };
  ThemedStyleSheet.registerInterface(aphroditeInterface);
  ThemedStyleSheet.registerTheme({
    reactDates: _objectSpread2({}, DefaultTheme.reactDates, {
      border: {
        input: _objectSpread2({}, DefaultTheme.reactDates.border.input, {
          border: 0,
          borderBottom: 0,
          borderBottomFocused: 0
        })
      },
      color: _objectSpread2({}, DefaultTheme.reactDates.color, {
        selected: _objectSpread2({}, DefaultTheme.reactDates.color.selected, {
          backgroundColor: core.primary,
          backgroundColor_active: core.primary,
          backgroundColor_hover: core.primary,
          borderColor: core.primary,
          borderColor_active: core.primary,
          borderColor_hover: core.primary
        })
      }),
      font: _objectSpread2({}, DefaultTheme.reactDates.font, {
        size: 14,
        captionSize: 18,
        input: _objectSpread2({}, DefaultTheme.reactDates.font.input, {
          size: 16
        })
      })
    })
  });
  var RESET = 'RESET';
  var UPDATE = 'UPDATE';
  var initialState = {
    values: {}
  };
  function booking() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch (action.type) {
      case RESET:
        return initialState;
      case UPDATE:
        var newValues = ((action || {}).payload || {}).values;
        return _objectSpread2({}, state, {
          values: _objectSpread2({}, state.values, {}, newValues)
        });
      default:
        return state;
    }
  }

  /* eslint-disable no-underscore-dangle */

  function configureStore(initialState) {
    return redux.createStore(booking, initialState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
  }
  /* eslint-enable */

  function reset() {
    return {
      type: RESET
    };
  }
  function update(payload) {
    return {
      type: UPDATE,
      payload: payload
    };
  }
  var BookingActions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    reset: reset,
    update: update
  });
  var propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    phrases: PropTypes.shape({
      placeholder: PropTypes.string.isRequired
    }).isRequired,
    dates: PropTypes.object,
    value: PropTypes.oneOfType([MomentPropTypes.momentObj, PropTypes.string]),
    loading: PropTypes.bool.isRequired,
    focused: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
  };
  var defaultProps = {
    value: null,
    loading: false,
    focused: false
  };
  var Datepicker = /*#__PURE__*/
  function (_React$Component) {
    _inherits(Datepicker, _React$Component);
    function Datepicker(props) {
      var _this;
      _classCallCheck(this, Datepicker);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(Datepicker).call(this, props));
      _this.state = {
        focused: false
      };
      return _this;
    }
    _createClass(Datepicker, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        // If the provided dates change and a date has been selected, check the new
        //  dates for availability and possibly reset
        if (prevProps.dates !== this.props.dates && this.props.value !== null) {
          if (!this.props.dates[moment(this.props.value).format('YYYY-MM-DD')]) {
            this.props.onChange(this.props.name, null);
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var numberOfMonths = window.innerWidth < 640 ? 1 : 2;
        var withPortal = window.innerWidth < 768;
        var focused = this.state.focused;
        var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          value = _this$props.value,
          onChange = _this$props.onChange,
          loading = _this$props.loading,
          dates = _this$props.dates,
          phrases = _this$props.phrases;
        var date = value ? moment(value) : value;
        return React.createElement("div", {
          className: "booking-datepicker"
        }, React.createElement(reactDates.SingleDatePicker, {
          block: true,
          id: id,
          date: date,
          onDateChange: function onDateChange(date) {
            return date && onChange(name, date.format('YYYY-MM-DD'));
          },
          focused: focused,
          disabled: loading === true,
          onFocusChange: function onFocusChange(_ref) {
            var focused = _ref.focused;
            return _this2.setState({
              focused: focused
            });
          },
          isDayBlocked: function isDayBlocked(date) {
            return dates && !dates[date.format('YYYY-MM-DD')];
          },
          numberOfMonths: numberOfMonths,
          placeholder: phrases.placeholder,
          displayFormat: "YYYY-MM-DD",
          withPortal: withPortal
        }), loading && React.createElement("div", {
          className: "booking-datepicker__spinner"
        }));
      }
    }]);
    return Datepicker;
  }(React.Component);
  Datepicker.propTypes = propTypes;
  Datepicker.defaultProps = defaultProps;
  var propTypes$1 = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired
  };
  var defaultProps$1 = {
    value: 0
  };
  function normalizeValue(value) {
    if (value === '') {
      return 0;
    } else if (!isNaN(value)) {
      return parseInt(value, 10);
    }
  }
  var NumberSpinner = /*#__PURE__*/
  function (_React$Component) {
    _inherits(NumberSpinner, _React$Component);
    function NumberSpinner(props) {
      var _this;
      _classCallCheck(this, NumberSpinner);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberSpinner).call(this));
      _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
      _this.onMinClick = _this.onMinClick.bind(_assertThisInitialized(_this));
      _this.onPlusClick = _this.onPlusClick.bind(_assertThisInitialized(_this));
      _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(NumberSpinner, [{
      key: "onMinClick",
      value: function onMinClick() {
        if (this.props.value - 1 >= this.props.min) {
          this.props.onChange(this.props.name, this.props.value - 1);
        }
      }
    }, {
      key: "onPlusClick",
      value: function onPlusClick() {
        if (this.props.value + 1 <= this.props.max) {
          this.props.onChange(this.props.name, this.props.value + 1);
        }
      }
    }, {
      key: "onChange",
      value: function onChange(event) {
        var newValue = normalizeValue(event.target.value);
        if (_typeof(newValue !== 'undefined') && newValue !== this.props.value && newValue >= this.props.min && newValue <= this.props.max) {
          this.props.onChange(this.props.name, newValue);
        }
      }
    }, {
      key: "onBlur",
      value: function onBlur() {
        var value = this.props.value;
        if (value > this.props.max) value = this.props.max;
        if (value < this.props.min) value = this.props.min;
        if (value !== this.props.value) this.props.onChange(value);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          id = _this$props.id,
          value = _this$props.value,
          min = _this$props.min,
          max = _this$props.max;
        return React.createElement("div", {
          className: "booking-number-spinner"
        }, React.createElement("button", {
          type: "button",
          className: cn({
            'booking-number-spinner__min': true,
            'booking-number-spinner__min--disabled': value === min
          }),
          onClick: this.onMinClick
        }, React.createElement("svg", {
          className: "booking-number-spinner__button-icon",
          width: "1792",
          height: "1792",
          viewBox: "0 0 1792 1792",
          xmlns: "http://www.w3.org/2000/svg"
        }, React.createElement("path", {
          d: "M1600 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z"
        }))), React.createElement("input", {
          type: "text",
          id: id,
          name: id,
          className: "booking-number-spinner__input",
          value: value || 0,
          onBlur: this.onBlur,
          onChange: this.onChange,
          autoComplete: "off"
        }), React.createElement("button", {
          type: "button",
          className: cn({
            'booking-number-spinner__plus': true,
            'booking-number-spinner__plus--disabled': value === max
          }),
          onClick: this.onPlusClick
        }, React.createElement("svg", {
          className: "booking-number-spinner__button-icon",
          width: "1792",
          height: "1792",
          viewBox: "0 0 1792 1792",
          xmlns: "http://www.w3.org/2000/svg"
        }, React.createElement("path", {
          d: "M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"
        }))));
      }
    }]);
    return NumberSpinner;
  }(React.Component);
  NumberSpinner.propTypes = propTypes$1;
  NumberSpinner.defaultProps = defaultProps$1;
  var propTypes$2 = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired
    }).isRequired).isRequired,
    onChange: PropTypes.func.isRequired
  };
  function selectOption(option) {
    return React.createElement("option", {
      key: option.value,
      value: option.value
    }, option.label);
  }
  var Select = function Select(props) {
    return React.createElement("div", {
      className: "booking-select"
    }, React.createElement("select", {
      id: props.id,
      className: "booking-select__select select-css",
      name: props.id,
      value: props.value,
      onChange: function onChange(event) {
        props.onChange(props.name, event.target.value);
      }
    }, props.options.map(selectOption)));
  };
  Select.propTypes = propTypes$2;
  function timeToMinutes(time) {
    if (!time) return 0;
    var _time$split = time.split(':'),
      _time$split2 = _slicedToArray(_time$split, 2),
      hours = _time$split2[0],
      minutes = _time$split2[1];
    return parseInt(hours, 10) * 60 + parseInt(minutes, 10);
  }

  // Validations methods must return the key of the validation message if not valid
  function validatePresence(value) {
    if (typeof value === 'undefined' || value === null || value === '') {
      return 'presence';
    }
    return null;
  }
  var propTypes$3 = {
    modelParam: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    identifier: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, MomentPropTypes.momentObj]),
    phrases: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    dates: PropTypes.object,
    loadingDates: PropTypes.bool.isRequired,
    times: PropTypes.array,
    validationMessage: PropTypes.string
  };
  var defaultProps$2 = {
    modelParam: 'booking',
    loadingDates: false,
    validationMessage: null
  };
  function input(props) {
    var inputId = props.inputId,
      data = props.data,
      identifier = props.identifier,
      value = props.value,
      phrases = props.phrases,
      onChange = props.onChange;
    var inputProps = {
      id: inputId,
      key: identifier,
      name: identifier,
      value: value,
      onChange: onChange
    };
    if (identifier === 'inbound_date') {
      var dates = props.dates,
        loadingDates = props.loadingDates;
      return React.createElement(Datepicker, _extends({}, inputProps, {
        dates: dates,
        value: value && moment(value),
        phrases: {
          placeholder: phrases.placeholder
        },
        loading: loadingDates
      }));
    } else if (identifier === 'inbound_min') {
      var times = props.times;
      if (times.length > 0) {
        return React.createElement(Select, _extends({}, inputProps, {
          options: times.map(function (time) {
            return {
              value: timeToMinutes(time),
              label: time
            };
          })
        }));
      }
    } else if (data.form_tag === 'number_spinner') {
      return React.createElement(NumberSpinner, _extends({}, inputProps, {
        min: data.min,
        max: data.max
      }));
    } else if (data.form_tag === 'select') {
      return React.createElement(Select, _extends({}, inputProps, {
        options: data.select_options.map(function (option) {
          return {
            value: option,
            label: phrases.values[option]
          };
        })
      }));
    } else {
      return null;
    }
  }
  var BookingFormMandatory = /*#__PURE__*/
  function (_React$Component) {
    _inherits(BookingFormMandatory, _React$Component);
    function BookingFormMandatory() {
      _classCallCheck(this, BookingFormMandatory);
      return _possibleConstructorReturn(this, _getPrototypeOf(BookingFormMandatory).apply(this, arguments));
    }
    _createClass(BookingFormMandatory, [{
      key: "isHidden",
      value: function isHidden() {
        var _this$props = this.props,
          identifier = _this$props.identifier,
          times = _this$props.times;
        if (identifier === 'inbound_min' && times.length === 0) return true;
        return false;
      }
    }, {
      key: "validationMessages",
      value: function validationMessages() {
        var _this$props2 = this.props,
          data = _this$props2.data,
          value = _this$props2.value;
        var validations = data.validations;
        var messages = [];
        if (data.validations) {
          validations.forEach(function (validation) {
            if (validation.hasOwnProperty('presence')) {
              var message = validatePresence(value);
              if (message) messages.push(message);
            }
          });
        }
        return messages;
      }
    }, {
      key: "render",
      value: function render() {
        var _cn;
        var _this$props3 = this.props,
          modelParam = _this$props3.modelParam,
          data = _this$props3.data,
          identifier = _this$props3.identifier,
          phrases = _this$props3.phrases,
          validationMessage = _this$props3.validationMessage;
        var inputId = "".concat(modelParam, "[").concat(identifier, "]");
        var isHidden = this.isHidden();
        return React.createElement("div", {
          className: cn((_cn = {
            'booking-mandatory': true
          }, _defineProperty(_cn, "booking-mandatory--".concat(data.form_tag), true), _defineProperty(_cn, 'booking-mandatory--hidden', isHidden), _defineProperty(_cn, 'booking-mandatory--erroneous', validationMessage !== null), _cn)),
          key: identifier
        }, React.createElement("label", {
          htmlFor: inputId,
          className: "booking-mandatory__label"
        }, "".concat(phrases.label) + (validationMessage === null ? '' : " (".concat(validationMessage, ")"))), React.createElement("div", {
          className: "booking-mandatory__input"
        }, input(_objectSpread2({}, this.props, {
          inputId: inputId
        }))));
      }
    }]);
    return BookingFormMandatory;
  }(React.Component);
  BookingFormMandatory.propTypes = propTypes$3;
  BookingFormMandatory.defaultProps = defaultProps$2;
  var propTypes$4 = {
    locale: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    exchangeRate: PropTypes.number.isRequired,
    priceCents: PropTypes.number.isRequired
  };
  var PricingTotal = function PricingTotal(props) {
    return React.createElement("div", {
      className: "booking-pricing-total"
    }, CurrencyFormatter.format(props.priceCents / props.exchangeRate / 100, {
      currency: props.currency,
      locale: props.locale
    }));
  };
  PricingTotal.propTypes = propTypes$4;
  var PaymentDebitSvg = function PaymentDebitSvg(props) {
    return React.createElement("svg", props, React.createElement("path", {
      d: "M10 20a.5.5 0 0 1-.393-.191c-.057-.073-1.418-1.814-2.797-4.385-.812-1.513-1.46-2.999-1.925-4.416C4.298 9.221 4.001 7.536 4.001 6c0-3.308 2.692-6 6-6 1.244 0 2.437.377 3.451 1.091a.5.5 0 1 1-.576.818A4.97 4.97 0 0 0 10.001 1c-2.757 0-5 2.243-5 5 0 3.254 1.463 6.664 2.691 8.951a34.411 34.411 0 0 0 2.309 3.71 34.276 34.276 0 0 0 2.214-3.533c1.192-2.19 2.642-5.468 2.776-8.649a.5.5 0 1 1 .999.042c-.063 1.498-.399 3.132-.998 4.855a28.384 28.384 0 0 1-1.908 4.246c-1.343 2.464-2.636 4.118-2.69 4.187a.5.5 0 0 1-.393.191z"
    }), React.createElement("path", {
      d: "M10 9a.502.502 0 0 1-.354-.146l-2.5-2.5a.5.5 0 0 1 .707-.707l2.146 2.146 5.146-5.146a.5.5 0 0 1 .707.707l-5.5 5.5A.498.498 0 0 1 9.998 9z"
    }));
  };
  PaymentDebitSvg.defaultProps = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  };
  var PaymentSafeSvg = function PaymentSafeSvg(props) {
    return React.createElement("svg", props, React.createElement("g", {
      fill: "#1D9FC9",
      fillRule: "evenodd"
    }, React.createElement("path", {
      d: "M16.15 34a.855.855 0 0 1-.269-.044c-3.126-1.042-7.05-4.507-9.996-8.828A33.904 33.904 0 0 1 0 5.948c0-.469.38-.85.85-.85 4.784 0 12.305-3.274 14.83-4.957a.85.85 0 0 1 .943 0c2.524 1.683 10.045 4.957 14.829 4.957a.85.85 0 0 1 .85.85c0 8.718-3.201 15.24-5.886 19.18-2.946 4.32-6.87 7.786-9.996 8.828a.855.855 0 0 1-.268.044h-.002zM1.71 6.773a32.19 32.19 0 0 0 5.58 17.4c3.007 4.41 6.555 7.19 8.86 8.076 2.305-.886 5.853-3.665 8.86-8.077a32.19 32.19 0 0 0 5.58-17.4c-2.768-.173-5.852-1.125-8.041-1.937-2.41-.893-4.843-2.028-6.399-2.977-1.555.949-3.988 2.084-6.399 2.977-2.191.81-5.273 1.764-8.04 1.938z"
    }), React.createElement("path", {
      d: "M14.45 21.25a.854.854 0 0 1-.602-.248l-3.4-3.4A.85.85 0 0 1 11.65 16.4l2.798 2.798 7.898-7.898a.85.85 0 0 1 1.202 1.202l-8.5 8.5a.847.847 0 0 1-.601.248h.003z"
    })));
  };
  PaymentSafeSvg.defaultProps = {
    viewBox: "0 0 33 34",
    xmlns: "http://www.w3.org/2000/svg"
  };
  var propTypes$5 = {
    type: PropTypes.string.isRequired,
    phrases: PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired
    }).isRequired
  };
  var Payment = function Payment(props) {
    return React.createElement("div", {
      className: "booking-payment"
    }, React.createElement("div", {
      className: "booking-payment__illustration"
    }, props.type === 'debit' ? React.createElement(PaymentDebitSvg, null) : React.createElement(PaymentSafeSvg, null)), React.createElement("div", {
      className: "booking-payment__copy"
    }, React.createElement("b", {
      className: "booking-payment__title"
    }, props.phrases.title), React.createElement("p", {
      className: "booking-payment__subtitle"
    }, props.phrases.subtitle)));
  };
  Payment.propTypes = propTypes$5;
  function mandatoriesOptionsPriceCents(mandatories, values, identifier) {
    var price = 0;
    var pricing = mandatories[identifier].mandatories_options_price_cents;
    Object.keys(pricing).forEach(function (mandatory) {
      var value = values[mandatory];
      price += pricing[mandatory][value] || 0;
    });
    return {
      count: values[identifier],
      priceCents: price,
      totalPriceCents: price * values[identifier],
      identifier: identifier
    };
  }
  function mandatoriesOptionsTieredFixedPriceCents(mandatories, values, identifier) {
    var price = 0;
    var pricing = mandatories[identifier].mandatories_options_tiered_fixed_price_cents;
    Object.keys(pricing).forEach(function (mandatory) {
      var value = values[mandatory];
      var tiers = pricing[mandatory][value];
      var tierCents = 0;
      if (value) {
        Object.keys(tiers).forEach(function (tier) {
          if (tier <= values[identifier]) {
            tierCents = tiers[tier];
          }
        });
        price += tierCents;
      }
    });
    return {
      count: values[identifier],
      priceCents: price,
      totalPriceCents: price,
      identifier: identifier
    };
  }
  function mandatoriesOptionsTieredPriceCents(mandatories, values, identifier) {
    var price = 0;
    var pricing = mandatories[identifier].mandatories_options_tiered_price_cents;
    Object.keys(pricing).forEach(function (mandatory) {
      var value = values[mandatory];
      var tiers = pricing[mandatory][value];
      var tierCents = 0;
      if (value) {
        Object.keys(tiers).forEach(function (tier) {
          if (tier <= values[identifier]) {
            tierCents = tiers[tier];
          }
        });
        price += tierCents;
      }
    });
    return {
      count: values[identifier],
      priceCents: price,
      totalPriceCents: price * values[identifier],
      identifier: identifier
    };
  }
  function optionsPriceCents(mandatories, values, identifier) {
    var price = 0;
    var pricing = mandatories[identifier].options_price_cents;
    var option = pricing[values[identifier].toString()];
    if (pricing && option) price = option;
    return {
      count: values[identifier],
      priceCents: price,
      totalPriceCents: price,
      identifier: identifier
    };
  }
  function priceCents(mandatories, values, identifier) {
    return {
      count: values[identifier],
      priceCents: mandatories[identifier].price_cents,
      totalPriceCents: mandatories[identifier].price_cents * values[identifier],
      identifier: identifier
    };
  }
  function tieredFixedPriceCents(mandatories, values, identifier) {
    var price = 0;
    var pricing = mandatories[identifier].tiered_fixed_price_cents;
    Object.keys(pricing).forEach(function (tier) {
      if (parseInt(tier, 10) <= values[identifier]) {
        price = pricing[tier];
      }
    });
    return {
      count: values[identifier],
      priceCents: price,
      totalPriceCents: price,
      identifier: identifier
    };
  }
  function tieredPriceCents(mandatories, values, identifier) {
    var price = 0;
    var pricing = mandatories[identifier].tiered_price_cents;
    Object.keys(pricing).forEach(function (tier) {
      if (parseInt(tier, 10) <= values[identifier]) {
        price = pricing[tier];
      }
    });
    return {
      count: values[identifier],
      priceCents: price,
      totalPriceCents: price * values[identifier],
      identifier: identifier
    };
  }
  function computePrice(mandatories, values) {
    var breakdown = [];
    var price = 0;
    Object.keys(values).forEach(function (identifier) {
      var mandatory = mandatories[identifier];
      if (mandatory) {
        var item;
        if (typeof mandatory.price_cents !== 'undefined') {
          item = priceCents(mandatories, values, identifier);
        } else if (typeof mandatory.mandatories_options_price_cents !== 'undefined') {
          item = mandatoriesOptionsPriceCents(mandatories, values, identifier);
        } else if (typeof mandatory.mandatories_options_tiered_price_cents !== 'undefined') {
          item = mandatoriesOptionsTieredPriceCents(mandatories, values, identifier);
        } else if (typeof mandatory.mandatories_options_tiered_fixed_price_cents !== 'undefined') {
          item = mandatoriesOptionsTieredFixedPriceCents(mandatories, values, identifier);
        } else if (typeof mandatory.tiered_price_cents !== 'undefined') {
          item = tieredPriceCents(mandatories, values, identifier);
        } else if (typeof mandatory.tiered_fixed_price_cents !== 'undefined') {
          item = tieredFixedPriceCents(mandatories, values, identifier);
        }
        if (typeof mandatory.options_price_cents !== 'undefined') {
          var optionPrice = optionsPriceCents(mandatories, values, identifier);
          if (optionPrice) item = optionPrice;
        }
        if (item) {
          breakdown.push(item);
          price += item.totalPriceCents;
        }
      }
    });
    return {
      breakdown: breakdown,
      price: price
    };
  }
  var CalendarHeartSvg = function CalendarHeartSvg(props) {
    return React.createElement("svg", props, React.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, React.createElement("path", {
      fill: "#F1F1F1",
      d: "M0 66h220v172H0z"
    }), React.createElement("path", {
      d: "M0 28.004A9.998 9.998 0 0 1 10.007 18h199.986C215.52 18 220 22.473 220 28.004V66H0V28.004z",
      fill: "#E53B51"
    }), React.createElement("path", {
      fill: "#40444A",
      d: "M30 0h28v38H30zm132 0h28v38h-28z"
    }), React.createElement("path", {
      fill: "#D3D7D9",
      d: "M28 94h32v32H28zm44 0h32v32H72zm44 0h32v32h-32zm44 0h32v32h-32zM28 136h32v32H28zm44 0h32v32H72zm44 0h32v32h-32zm44 0h32v32h-32zM28 178h32v32H28zm44 0h32v32H72z"
    }), React.createElement("path", {
      fill: "#444A4D",
      d: "M116 178h32v32h-32z"
    }), React.createElement("path", {
      fill: "#D3D7D9",
      d: "M160 178h32v32h-32z"
    }), React.createElement("circle", {
      fill: "#FFCA58",
      cx: "228.5",
      cy: "105.5",
      r: "77.5"
    }), React.createElement("path", {
      d: "M136.153 193.851c-5.35-5.35 23.519-42.07 18.847-77.831-4.672-35.762 113.718 86.75 67.004 64.285-46.715-22.465-80.502 18.896-85.851 13.546z",
      fill: "#FFCA58"
    }), React.createElement("path", {
      d: "M228 149a2.15 2.15 0 0 1-1.074-.29c-.416-.238-10.284-5.968-20.302-15.356-5.928-5.552-10.659-11.232-14.072-16.885-4.35-7.208-6.552-14.402-6.552-21.38C186 81.804 196.412 71 209.21 71c4.333 0 8.935 1.684 12.959 4.744 2.352 1.79 4.354 3.946 5.831 6.236 1.477-2.29 3.48-4.446 5.831-6.236 4.024-3.06 8.626-4.744 12.958-4.744C259.59 71 270 81.805 270 95.088c0 6.979-2.206 14.173-6.552 21.381-3.409 5.653-8.144 11.333-14.068 16.885-10.018 9.388-19.886 15.118-20.301 15.357a2.15 2.15 0 0 1-1.075.289H228z",
      fill: "#E53B51"
    })));
  };
  CalendarHeartSvg.defaultProps = {
    width: "306",
    height: "238",
    viewBox: "0 0 306 238",
    xmlns: "http://www.w3.org/2000/svg"
  };
  var propTypes$6 = {
    locale: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    exchangeRate: PropTypes.number.isRequired,
    bookingsPath: PropTypes.string.isRequired,
    csrfToken: PropTypes.string.isRequired,
    modelParam: PropTypes.string.isRequired,
    mandatories: PropTypes.object.isRequired,
    defaultValues: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    submittingForm: PropTypes.bool.isRequired,
    loadingDates: PropTypes.bool.isRequired,
    dates: PropTypes.object,
    times: PropTypes.array,
    phrases: PropTypes.shape({
      fieldsetTitle: PropTypes.string.isRequired,
      fieldsetSubtitle: PropTypes.string.isRequired,
      pricingLabel: PropTypes.string.isRequired,
      cancellationText: PropTypes.string,
      submitButton: PropTypes.string.isRequired
    }).isRequired,
    payment: PropTypes.shape({
      type: PropTypes.string.isRequired,
      phrases: PropTypes.shape({
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    onMandatoryChange: PropTypes.func.isRequired,
    mandatoryInputs: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired
  };
  var defaultProps$3 = {
    modelParam: 'booking'
  };
  var BookingForm = /*#__PURE__*/
  function (_React$Component) {
    _inherits(BookingForm, _React$Component);
    function BookingForm() {
      _classCallCheck(this, BookingForm);
      return _possibleConstructorReturn(this, _getPrototypeOf(BookingForm).apply(this, arguments));
    }
    _createClass(BookingForm, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          locale = _this$props.locale,
          currency = _this$props.currency,
          exchangeRate = _this$props.exchangeRate,
          bookingsPath = _this$props.bookingsPath,
          onSubmit = _this$props.onSubmit,
          phrases = _this$props.phrases,
          csrfToken = _this$props.csrfToken,
          defaultValues = _this$props.defaultValues,
          payment = _this$props.payment,
          mandatories = _this$props.mandatories,
          values = _this$props.values,
          onMandatoryChange = _this$props.onMandatoryChange,
          dates = _this$props.dates,
          submittingForm = _this$props.submittingForm,
          loadingDates = _this$props.loadingDates,
          times = _this$props.times,
          mandatoryInputs = _this$props.mandatoryInputs,
          validationMessages = _this$props.validationMessages;
        var price = computePrice(mandatories, values);
        var mandatoryFormInputs = Object.keys(omit(mandatories, function (val) {
          return typeof val.form_tag !== 'undefined';
        })).map(function (identifier) {
          return React.createElement(BookingFormMandatory, {
            ref: function ref(el) {
              return mandatoryInputs[identifier] = el;
            },
            key: identifier,
            data: mandatories[identifier],
            identifier: identifier,
            value: values[identifier],
            phrases: phrases.mandatories[identifier],
            onChange: onMandatoryChange,
            dates: dates,
            loadingDates: loadingDates,
            times: times,
            validationMessage: validationMessages[identifier] ? phrases.validations[validationMessages[identifier]] : null
          });
        });
        return React.createElement("form", {
          className: "booking-form",
          action: bookingsPath,
          method: "post",
          onSubmit: onSubmit
        }, React.createElement("fieldset", {
          className: "booking-form__fieldset",
          disabled: submittingForm
        }, React.createElement("legend", {
          className: "booking-form__legend"
        }, React.createElement(CalendarHeartSvg, {
          className: "booking-form__icon"
        }), React.createElement("span", {
          className: "booking-form__title"
        }, phrases.fieldsetTitle), React.createElement("span", {
          className: "booking-form__subtitle"
        }, phrases.fieldsetSubtitle)), mandatoryFormInputs, React.createElement("input", {
          type: "hidden",
          name: "authenticity_token",
          value: csrfToken
        }), Object.keys(defaultValues).map(function (attribute) {
          return React.createElement("input", {
            key: attribute,
            type: "hidden",
            name: "booking[".concat(attribute, "]"),
            value: defaultValues[attribute]
          });
        }), React.createElement("div", {
          className: "booking-form__actions"
        }, React.createElement("div", {
          className: "booking-form-pricing"
        }, React.createElement("span", {
          className: "booking-form-pricing__label"
        }, phrases.pricingLabel), React.createElement(PricingTotal, {
          locale: locale,
          currency: currency,
          exchangeRate: exchangeRate,
          priceCents: price.price
        })), React.createElement("input", {
          type: "submit",
          className: "booking-form__submit",
          value: phrases.submitButton
        })), phrases.cancellationText && React.createElement("div", {
          className: "booking-form__cancellation"
        }, phrases.cancellationText), React.createElement(Payment, payment)));
      }
    }]);
    return BookingForm;
  }(React.Component);
  BookingForm.propTypes = propTypes$6;
  BookingForm.defaultProps = defaultProps$3;
  var propTypes$7 = {
    locale: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    exchangeRate: PropTypes.number.isRequired,
    bookingsPath: PropTypes.string.isRequired,
    tokenPath: PropTypes.string,
    availabilityPaths: PropTypes.object,
    startDate: MomentPropTypes.momentObj,
    endDate: MomentPropTypes.momentObj,
    mandatories: PropTypes.object.isRequired,
    defaultValues: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    phrases: PropTypes.object.isRequired,
    payment: PropTypes.shape({
      type: PropTypes.string.isRequired,
      phrases: PropTypes.shape({
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    onMandatoryChange: PropTypes.func.isRequired
  };
  var defaultProps$4 = {
    startDate: moment(),
    endDate: moment().add(1, 'year').endOf('year')
  };
  function mapStateToProps(state) {
    return {
      values: state.values
    };
  }
  function mapDispatchToProps(dispatch) {
    return redux.bindActionCreators(BookingActions, dispatch);
  }
  var BookingFormContainer = /*#__PURE__*/
  function (_React$Component) {
    _inherits(BookingFormContainer, _React$Component);
    function BookingFormContainer(props) {
      var _this;
      _classCallCheck(this, BookingFormContainer);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(BookingFormContainer).call(this, props));
      _this.state = {
        csrfToken: '',
        dates: null,
        times: props.times,
        submittingForm: false,
        loadingDates: false,
        validationMessages: {}
      };
      _this.mandatoryInputs = {};
      _this.onMandatoryChange = _this.onMandatoryChange.bind(_assertThisInitialized(_this));
      _this.onFormSubmit = _this.onFormSubmit.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(BookingFormContainer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.fetchDates();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevProps.values.language !== this.props.values.language) {
          this.fetchDates();
        }
      }
    }, {
      key: "onMandatoryChange",
      value: function onMandatoryChange(identifier, value) {
        this.props.onMandatoryChange(identifier, value);
        if (identifier === 'inbound_date' && this.state.dates && this.props.mandatories.inbound_min) {
          // (Re)set the times if the date changes
          this.setState({
            times: this.state.dates[value] || []
          }, this.resetInboundMinValue);
        }
      }
    }, {
      key: "onFormSubmit",
      value: function onFormSubmit(event) {
        var _this2 = this;
        if (!this.state.isValid) {
          event.persist();
          event.preventDefault();
          this.setState({
            validationMessages: {}
          }, function () {
            var validationMessages = {};
            entries(_this2.mandatoryInputs).forEach(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                identifier = _ref2[0],
                input = _ref2[1];
              var messages = input.validationMessages();
              if (messages.length) validationMessages[identifier] = messages;
            });
            if (Object.keys(validationMessages).length > 0) {
              _this2.setState({
                validationMessages: validationMessages
              });
            } else {
              _this2.setState({
                submittingForm: true
              }, function () {
                _this2.fetchToken().then(function (token) {
                  _this2.setState({
                    csrfToken: token,
                    submittingForm: false,
                    isValid: true
                  }, function () {
                    event.target.submit();
                  });
                });
              });
            }
          });
        }
      }
    }, {
      key: "shouldProvideDates",
      value: function shouldProvideDates() {
        return typeof this.props.mandatories.inbound_date !== 'undefined' && typeof this.props.availabilityPaths[this.props.values.language] !== 'undefined';
      }
    }, {
      key: "resetInboundMinValue",
      value: function resetInboundMinValue() {
        if (this.state.times.length === 0) return;
        this.props.onMandatoryChange('inbound_min', timeToMinutes(this.state.times[0]));
      }
    }, {
      key: "fetchDates",
      value: function fetchDates() {
        var _this3 = this;
        if (!this.shouldProvideDates()) return;
        this.setState({
          loadingDates: true
        }, function () {
          fetch(_this3.remoteUrl(), {
            credentials: 'same-origin'
          }).then(function (response) {
            return response.json();
          }).then(function (response) {
            var times = [];
            if (_this3.state.times.length) {
              times = response[_this3.props.values.inbound_date] || [];
            }
            _this3.setState({
              dates: response,
              loadingDates: false,
              times: times
            }, _this3.resetInboundMinValue);
          });
        });
      }
    }, {
      key: "fetchToken",
      value: function fetchToken() {
        return fetch(this.props.tokenPath, {
          credentials: 'same-origin'
        }).then(function (response) {
          return response.text();
        });
      }
    }, {
      key: "remoteUrl",
      value: function remoteUrl() {
        return "".concat(this.props.availabilityPaths[this.props.values.language], "?schedule[start_time]=").concat(this.props.startDate.format(), "&schedule[end_time]=").concat(this.props.endDate.format());
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          locale = _this$props.locale,
          currency = _this$props.currency,
          exchangeRate = _this$props.exchangeRate,
          bookingsPath = _this$props.bookingsPath,
          mandatories = _this$props.mandatories,
          defaultValues = _this$props.defaultValues,
          values = _this$props.values,
          phrases = _this$props.phrases,
          payment = _this$props.payment;
        var _this$state = this.state,
          csrfToken = _this$state.csrfToken,
          dates = _this$state.dates,
          times = _this$state.times,
          submittingForm = _this$state.submittingForm,
          loadingDates = _this$state.loadingDates,
          validationMessages = _this$state.validationMessages;
        return React.createElement(BookingForm, {
          locale: locale,
          currency: currency,
          exchangeRate: exchangeRate,
          bookingsPath: bookingsPath,
          csrfToken: csrfToken,
          mandatories: mandatories,
          defaultValues: defaultValues,
          values: values,
          dates: dates,
          times: times,
          phrases: phrases,
          payment: payment,
          submittingForm: submittingForm,
          loadingDates: loadingDates,
          onMandatoryChange: this.onMandatoryChange,
          mandatoryInputs: this.mandatoryInputs,
          onSubmit: this.onFormSubmit,
          validationMessages: validationMessages
        });
      }
    }]);
    return BookingFormContainer;
  }(React.Component);
  BookingFormContainer.propTypes = propTypes$7;
  BookingFormContainer.defaultProps = defaultProps$4;
  var BookingFormContainer$1 = reactRedux.connect(mapStateToProps, mapDispatchToProps)(BookingFormContainer);
  var propTypes$8 = {
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    priceCents: PropTypes.number.isRequired,
    totalPriceCents: PropTypes.number.isRequired,
    identifier: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    exchangeRate: PropTypes.number.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    phrases: PropTypes.object.isRequired
  };
  var PricingBreakdownItem = /*#__PURE__*/
  function (_React$Component) {
    _inherits(PricingBreakdownItem, _React$Component);
    function PricingBreakdownItem(props) {
      var _this;
      _classCallCheck(this, PricingBreakdownItem);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(PricingBreakdownItem).call(this, props));
      _this.phrases = new Polyglot({
        phrases: props.phrases
      });
      return _this;
    }
    _createClass(PricingBreakdownItem, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          count = _this$props.count,
          priceCents = _this$props.priceCents,
          totalPriceCents = _this$props.totalPriceCents,
          identifier = _this$props.identifier,
          locale = _this$props.locale,
          currency = _this$props.currency,
          exchangeRate = _this$props.exchangeRate,
          value = _this$props.value,
          phrases = _this$props.phrases;
        var countText = parseInt(count, 10) ? count : 1;
        var identifierText;
        if (typeof phrases[identifier] === 'string') {
          identifierText = this.phrases.t("".concat(identifier), count);
        } else {
          identifierText = phrases[identifier][value];
        }
        return React.createElement("div", {
          className: "booking-pricing-breakdown-item"
        }, React.createElement("div", {
          className: "booking-pricing-breakdown-item__col booking-pricing-breakdown-item__col--left"
        }, React.createElement("span", {
          className: "booking-pricing-breakdown-item__count"
        }, countText, " x")), React.createElement("div", {
          className: "booking-pricing-breakdown-item__col booking-pricing-breakdown-item__col--middle"
        }, React.createElement("span", {
          className: "booking-pricing-breakdown-item__identifier"
        }, identifierText), React.createElement("span", {
          className: "booking-pricing-breakdown-item__price"
        }, CurrencyFormatter.format(priceCents / exchangeRate / 100, {
          currency: currency,
          locale: locale
        }))), React.createElement("div", {
          className: "booking-pricing-breakdown-item__col booking-pricing-breakdown-item__col--right"
        }, React.createElement("span", {
          className: "booking-pricing-breakdown-item__total-price"
        }, CurrencyFormatter.format(totalPriceCents / exchangeRate / 100, {
          currency: currency,
          locale: locale
        }))));
      }
    }]);
    return PricingBreakdownItem;
  }(React.Component);
  PricingBreakdownItem.propTypes = propTypes$8;
  var propTypes$9 = {
    locale: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    exchangeRate: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      priceCents: PropTypes.number.isRequired,
      totalPriceCents: PropTypes.number.isRequired,
      identifier: PropTypes.string.isRequired
    })),
    values: PropTypes.object.isRequired,
    phrases: PropTypes.shape({
      items: PropTypes.object.isRequired
    }).isRequired
  };
  var defaultProps$5 = {
    values: {}
  };
  var PricingBreakdown = function PricingBreakdown(props) {
    return React.createElement("div", {
      className: "booking-pricing-breakdown"
    }, React.createElement(reactTransitionGroup.TransitionGroup, null, props.items.map(function (item) {
      var count = item.count,
        priceCents = item.priceCents,
        totalPriceCents = item.totalPriceCents,
        identifier = item.identifier;
      return React.createElement(reactTransitionGroup.CSSTransition, {
        key: identifier,
        classNames: "booking-pricing-breakdown-item",
        timeout: {
          enter: 300,
          exit: 300
        }
      }, React.createElement(PricingBreakdownItem, {
        count: count,
        priceCents: priceCents,
        totalPriceCents: totalPriceCents,
        identifier: identifier,
        locale: props.locale,
        currency: props.currency,
        exchangeRate: props.exchangeRate,
        value: props.values[identifier],
        phrases: _defineProperty({}, identifier, props.phrases.items[identifier])
      }));
    })));
  };
  PricingBreakdown.propTypes = propTypes$9;
  PricingBreakdown.defaultProps = defaultProps$5;
  var propTypes$a = {
    locale: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    exchangeRate: PropTypes.number.isRequired,
    mandatories: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    phrases: PropTypes.shape({
      title: PropTypes.string.isRequired,
      totalLabel: PropTypes.string.isRequired,
      breakdown: PropTypes.object.isRequired
    }).isRequired
  };
  var defaultProps$6 = {
    values: {}
  };
  var Pricing = function Pricing(props) {
    var locale = props.locale,
      currency = props.currency,
      exchangeRate = props.exchangeRate,
      mandatories = props.mandatories,
      values = props.values,
      phrases = props.phrases;
    var price = computePrice(mandatories, values);
    return React.createElement("div", {
      className: "booking-pricing"
    }, React.createElement("h3", {
      className: "booking-pricing__title"
    }, phrases.title), React.createElement(PricingBreakdown, {
      locale: locale,
      currency: currency,
      exchangeRate: exchangeRate,
      items: price.breakdown.filter(function (item) {
        return item.count !== 0;
      }),
      values: values,
      phrases: phrases.breakdown
    }), React.createElement("div", {
      className: "booking-pricing__total"
    }, React.createElement("h4", {
      className: "booking-pricing__total-label"
    }, phrases.totalLabel), React.createElement(PricingTotal, {
      locale: locale,
      currency: currency,
      exchangeRate: exchangeRate,
      priceCents: price.price
    })));
  };
  Pricing.propTypes = propTypes$a;
  Pricing.defaultProps = defaultProps$6;
  var propTypes$b = {
    locale: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    exchangeRate: PropTypes.number.isRequired,
    mandatories: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    phrases: PropTypes.shape({
      breakdown: PropTypes.object.isRequired
    }).isRequired
  };
  function mapStateToProps$1(state) {
    return {
      values: state.values
    };
  }
  function mapDispatchToProps$1(dispatch) {
    return redux.bindActionCreators(BookingActions, dispatch);
  }
  var PricingContainer = function PricingContainer(props) {
    return React.createElement(Pricing, props);
  };
  PricingContainer.propTypes = propTypes$b;
  var PricingContainer$1 = reactRedux.connect(mapStateToProps$1, mapDispatchToProps$1)(PricingContainer);
  var propTypes$c = {
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
    answerVisible: PropTypes.bool.isRequired,
    onQuestionClick: PropTypes.func.isRequired
  };
  var FaqItem = function FaqItem(props) {
    return React.createElement("li", {
      className: cn({
        'booking-faq-item': true,
        'booking-faq-item--with-answer': props.answerVisible
      })
    }, React.createElement("button", {
      className: "booking-faq-item__question",
      onClick: function onClick() {
        return props.onQuestionClick(props.answer);
      }
    }, props.question), React.createElement("div", {
      className: "booking-faq-item__answer"
    }, React.createElement("div", {
      className: "booking-faq-item__answer-content"
    }, props.answer)));
  };
  FaqItem.propTypes = propTypes$c;
  var propTypes$d = {
    items: PropTypes.arrayOf(PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired
    })).isRequired,
    phrases: PropTypes.shape({
      title: PropTypes.string.isRequired
    })
  };
  var Faq = /*#__PURE__*/
  function (_React$Component) {
    _inherits(Faq, _React$Component);
    function Faq(props) {
      var _this;
      _classCallCheck(this, Faq);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(Faq).call(this, props));
      _this.state = {
        visibleAnswer: null
      };
      _this.onItemQuestionClick = _this.onItemQuestionClick.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(Faq, [{
      key: "onItemQuestionClick",
      value: function onItemQuestionClick(answer) {
        if (this.state.visibleAnswer === answer) {
          this.setState({
            visibleAnswer: null
          });
        } else {
          this.setState({
            visibleAnswer: answer
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props = this.props,
          items = _this$props.items,
          phrases = _this$props.phrases;
        var visibleAnswer = this.state.visibleAnswer;
        return React.createElement("div", {
          className: "booking-faq"
        }, React.createElement("h3", {
          className: "booking-faq__title"
        }, phrases.title), React.createElement("ul", {
          className: "booking-faq__list"
        }, items.map(function (item) {
          return React.createElement(FaqItem, {
            key: item.question,
            question: item.question,
            answer: item.answer,
            answerVisible: visibleAnswer === item.answer,
            onQuestionClick: function onQuestionClick(answer) {
              _this2.onItemQuestionClick(answer);
            }
          });
        })));
      }
    }]);
    return Faq;
  }(React.Component);
  Faq.propTypes = propTypes$d;
  var store = configureStore();
  var propTypes$e = {
    locale: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    exchangeRate: PropTypes.number.isRequired,
    mandatories: PropTypes.object.isRequired,
    times: PropTypes.array,
    form: PropTypes.shape({
      bookingsPath: PropTypes.string.isRequired,
      availabilityPaths: PropTypes.object,
      startDate: MomentPropTypes.momentObj,
      endDate: MomentPropTypes.momentObj,
      defaultValues: PropTypes.object.isRequired,
      phrases: PropTypes.shape({
        fieldsetTitle: PropTypes.string.isRequired,
        fieldsetSubtitle: PropTypes.string.isRequired,
        pricingLabel: PropTypes.string.isRequired,
        submitButton: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    payment: PropTypes.shape({
      type: PropTypes.string.isRequired,
      phrases: PropTypes.shape({
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    pricing: PropTypes.shape({
      values: PropTypes.object.isRequired,
      phrases: PropTypes.shape({
        title: PropTypes.string.isRequired,
        totalLabel: PropTypes.string.isRequired,
        breakdown: PropTypes.object.isRequired
      }).isRequired
    }).isRequired,
    faq: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({
        question: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired
      })).isRequired
    }).isRequired
  };
  var defaultProps$7 = {
    times: [],
    pricing: {
      values: {}
    }
  };
  function initialMandatoryValues(mandatories) {
    var values = {};
    entries(mandatories).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        identifier = _ref2[0],
        mandatory = _ref2[1];
      values[identifier] = typeof mandatory.initial_value === 'undefined' ? null : mandatory.initial_value;
    });
    return values;
  }
  var BookingApp = /*#__PURE__*/
  function (_React$Component) {
    _inherits(BookingApp, _React$Component);
    function BookingApp(props) {
      var _this;
      _classCallCheck(this, BookingApp);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(BookingApp).call(this, props));
      _this.state = {
        csrfToken: ''
      };
      return _this;
    }
    _createClass(BookingApp, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        moment.locale(document.documentElement.lang);
        store.dispatch(update({
          values: initialMandatoryValues(this.props.mandatories)
        }));
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        store.dispatch(reset());
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          locale = _this$props.locale,
          currency = _this$props.currency,
          exchangeRate = _this$props.exchangeRate,
          times = _this$props.times,
          mandatories = _this$props.mandatories,
          form = _this$props.form,
          payment = _this$props.payment,
          pricing = _this$props.pricing,
          faq = _this$props.faq;
        return React.createElement(reactRedux.Provider, {
          store: store
        }, React.createElement("div", {
          className: "booking-app"
        }, React.createElement(BookingFormContainer$1, _extends({}, form, {
          locale: locale,
          currency: currency,
          exchangeRate: exchangeRate,
          payment: payment,
          mandatories: mandatories,
          times: times,
          onMandatoryChange: function onMandatoryChange(identifier, value) {
            store.dispatch(update({
              values: _defineProperty({}, identifier, value)
            }));
          }
        })), React.createElement("aside", {
          className: "booking-sidebar"
        }, React.createElement(PricingContainer$1, _extends({}, pricing, {
          locale: locale,
          currency: currency,
          exchangeRate: exchangeRate,
          mandatories: mandatories
        })), React.createElement(Faq, faq))));
      }
    }]);
    return BookingApp;
  }(React.Component);
  BookingApp.propTypes = propTypes$e;
  BookingApp.defaultProps = defaultProps$7;
  exports.BookingApp = BookingApp;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});